class CollapsibleTab extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector('.collapsible-tab--toggle');
    this.description = this.querySelector('.collapsible-tab--content');
    this.description_wrapper = this.querySelector('.collapsible-tab--content-wrapper');

    this.load();
  }

  load() {
    ['click', 'keydown'].forEach(event_type => {
      this.toggleListener(event_type);
    });

    this.transitionListener();
  }

  toggleListener(event_type) {
    this.toggle.addEventListener(event_type, event => {
      if (event.type === 'keydown' && event.key !== 'Enter') {
        return;
      }

      const aria_expanded = this.toggle.getAttribute('aria-expanded') == 'true';
      this.toggle.setAttribute('aria-expanded', !aria_expanded);
      this.setTransitions(!aria_expanded);
    });
  }

  setTransitions(expand) {
    if (expand) {
      this.description_wrapper.style.height = `${this.description.offsetHeight}px`;
      this.description_wrapper.setAttribute('data-transition', 'forwards');
    } else {
      this.description_wrapper.style.height = '0px';
      this.description.setAttribute('data-transition', 'fade-out');
    }
  }

  transitionListener() {
    this.description_wrapper.addEventListener('transition:at_end', () => {
      this.description.setAttribute('data-transition', 'fade-in');
    });
  }
}

customElements.define('collapsible-tab-root', CollapsibleTab);
